import React, { useState } from 'react';
import EligibilityConditionGroup from './EligibilityConditionGroup';

const createCondition = (id) => ({
    id,
    field: 'online_is_anniversary',
    operator: '=',
    value: '',
});

const createGroup = (id, type = 'And') => ({
    id,
    type,
    conditions: [createCondition(`${id}-c1`)],
    afterConditions: [],
    children: [],
});

const EligibilityConditionsShared = () => {
    const [groups, setGroups] = useState([createGroup(1)]);

    const updateGroup = (groupId, changes) => {
        const walk = (items) =>
            items.map((group) => {
                if (group.id === groupId) {
                    return { ...group, ...changes, children: group.children || [] };
                }

                if (group.children && group.children.length) {
                    return {
                        ...group,
                        children: walk(group.children),
                    };
                }

                return group;
            });

        setGroups((prev) => walk(prev));
    };

    const addCondition = (groupId) => {
        const walk = (items) =>
            items.map((group) => {
                if (group.id === groupId) {
                    const targetConditions = (group.children && group.children.length > 0)
                        ? (group.afterConditions || [])
                        : group.conditions;

                    return {
                        ...group,
                        conditions: (group.children && group.children.length > 0) ? group.conditions : [
                            ...group.conditions,
                            createCondition(`${groupId}-c${group.conditions.length + 1}`),
                        ],
                        afterConditions: (group.children && group.children.length > 0)
                            ? [
                                ...targetConditions,
                                createCondition(`${groupId}-after-${(group.afterConditions || []).length + 1}`),
                            ]
                            : (group.afterConditions || []),
                    };
                }

                if (group.children && group.children.length) {
                    return {
                        ...group,
                        children: walk(group.children),
                    };
                }

                return group;
            });

        setGroups((prev) => walk(prev));
    };

    const addNestedGroup = (groupId) => {
        const walk = (items) =>
            items.map((group) => {
                if (group.id === groupId) {
                    return {
                        ...group,
                        children: [...(group.children || []), createGroup(Date.now(), 'Or')],
                    };
                }

                if (group.children && group.children.length) {
                    return {
                        ...group,
                        children: walk(group.children),
                    };
                }

                return group;
            });

        setGroups((prev) => walk(prev));
    };

    const removeCondition = (groupId, conditionId) => {
        const walk = (items) =>
            items.map((group) => {
                if (group.id === groupId) {
                    const nextConditions = group.conditions.filter((condition) => condition.id !== conditionId);
                    const nextAfterConditions = (group.afterConditions || []).filter((condition) => condition.id !== conditionId);

                    return {
                        ...group,
                        conditions: nextConditions.length ? nextConditions : [createCondition(`${groupId}-c1`)],
                        afterConditions: nextAfterConditions.length ? nextAfterConditions : [],
                    };
                }

                if (group.children && group.children.length) {
                    return {
                        ...group,
                        children: walk(group.children),
                    };
                }

                return group;
            });

        setGroups((prev) => walk(prev));
    };

    const removeGroup = (groupId) => {
        const walk = (items) => {
            const next = items
                .filter((group) => group.id !== groupId)
                .map((group) => ({
                    ...group,
                    children: group.children ? walk(group.children) : [],
                }));

            return next.length ? next : [createGroup(1)];
        };

        setGroups((prev) => walk(prev));
    };

    const renderGroup = (group) => (
        <EligibilityConditionGroup
            key={group.id}
            group={group}
            onChangeType={(id, type) => updateGroup(id, { type })}
            onAddCondition={addCondition}
            onAddNestedGroup={addNestedGroup}
            onRemoveGroup={removeGroup}
            onRemoveCondition={removeCondition}
        >
            {group.children && group.children.length > 0 && group.children.map((child) => renderGroup(child))}
        </EligibilityConditionGroup>
    );

    return (
        <>
            <div className='step-container'>
                <div className='step-content'>
                    <div className='step-section-title'>
                        Attribute Conditions
                    </div>

                    {groups.map((group) => renderGroup(group))}
                </div>
            </div>
        </>
    );
};

export default EligibilityConditionsShared;
